export const TRANSLATIONS = {
    initializing: {
        en: 'Initializing...',
        nl: 'Laden...',
        fr: 'Chargement...',
        de: 'Initialisiere...',
        es: 'Inicializando...'
    },
    errorDashboard: {
        en: 'Oops, we could not load this dashboard!',
        nl: 'Oeps, we konden het dashboard niet laden.',
        fr: 'Le chargement a echoué.',
        de: 'Hoppla, wir konnten dieses Dashboard nicht laden!',
        es: '¡Ups! No pudimos cargar este tablero.'
    },
    errorItem: {
        en: 'Oops, we could not load this item!',
        nl: 'Oeps, we konden de grafiek niet laden.',
        fr: 'Le chargement a echoué.',
        de: 'Hoppla, wir konnten dieses Diagramm nicht laden!',
        es: '¡Ups! No pudimos cargar este elemento.'
    }
};
export default TRANSLATIONS;
